"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _List = require("./List");

var _userProfile = require("user-profile");

var _decorators = require("decorators");

var _AccountList = babelHelpers.interopRequireWildcard(require("./AccountList"));

var _class, _descriptor, _descriptor2, _descriptor3, _temp;

var VideoReplyListItem = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(VideoReplyListItem, _Component);

  function VideoReplyListItem() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, VideoReplyListItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(VideoReplyListItem)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "item", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "onSelected", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "asLink", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    _this.state = {
      userProfile: (0, _userProfile.getUserProfileNow)()
    };
    return _this;
  }

  babelHelpers.createClass(VideoReplyListItem, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      (0, _userProfile.getUserProfile)().then(function (value) {
        _this2.setState({
          userProfile: value
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.state.userProfile) return null;
      return _react.default.createElement(_List.NotificationItem, {
        asLink: this.asLink,
        onSelected: this.onSelected,
        item: this.item,
        overlayType: "success",
        overlay: "reply"
      }, _react.default.createElement(_AccountList.default, {
        accounts: this.item.accounts
      }), this.item.accounts.length == 1 ? ' has ' : ' have ', this.item.commentOwner.id == this.state.userProfile.id ? null : ' also ', ' replied to ', this.item.commentOwner.id == this.state.userProfile.id ? ' your ' : this.item.accounts.length > 1 || this.item.accounts[0].id != this.item.commentOwner.id ? _react.default.createElement("span", null, _react.default.createElement(_AccountList.Account, {
        account: this.item.commentOwner
      }), "'s") : ' their ', ' video on ', _react.default.createElement("span", {
        className: "courseActivity"
      }, this.item.activity.title), ' in ', _react.default.createElement("span", {
        className: "catalogItem"
      }, this.item.catalogItem.title), ".");
    }
  }]);
  return VideoReplyListItem;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "item", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "onSelected", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "asLink", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return true;
  }
})), _class);
exports.default = VideoReplyListItem;